import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import {fetchBranchSubscriptionById} from "../../store/branch-subscription-slice";
import { useDispatch, useSelector } from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Detail from "../../components/common/detail/Detail";
import { getDetailData } from "../../models/branchSubscriptionModel";
import {getValidatedLimit} from "../../components/Utility";

const BranchSubscriptionDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.globalSubscription);
    const {limit, currentPage} = getValidatedLimit(pagination);

    useEffect(() => {
        dispatch(fetchBranchSubscriptionById(params.globalBranchSubscription));
    }, [dispatch, params.globalBranchSubscription]);

    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector(state => state.globalSubscription);

    const item = items.find(item => item._id === params.globalBranchSubscription);
    const detailData = getDetailData({ item });

    return (
        <>
            <SubHeader title="Subscription Deatils">
                <Button to={`../?page=${currentPage}&limit=${limit}`} className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" && <Detail inline={true} columns={{ lg: 9, xl: 7 }} data={detailData} />}
            </div>
        </>
    );
};

export default BranchSubscriptionDetail;
